import { Delete } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import MovingService from "app/apis/Goeasy/Moving/MovingService";
import BreadCrumbs from "app/components/Breadcrumbs/Breadcrumbs";
import { PrimaryButton } from "app/components/Buttons/Button";
import AddBookingVehicle from "app/components/Dialog/AddBookingVehicle";
import { ErrorToaster, SuccessToaster } from "app/components/Toaster/Toaster";
import Layout from "app/layout/Layout";
import colors from "app/styles/colors";
import React, { useEffect, useState } from "react";

function MovingVehicle() {
  const [dataList, setDataList] = useState([]);
  const [listLoader, setListLoader] = useState(true);
  const [selectedData, setSelectedData] = useState();
  const [showDialog, setShowDialog] = useState(false);

  const getAllVehicles = async () => {
    try {
      setShowDialog(false);
      let { data, success } = await MovingService.getVehicle();
      if (success) {
        setDataList(data);
      }
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setListLoader(false);
    }
  };

  const deleteItem = async (id) => {
    try {
      let { success } = await MovingService.deleteVehicle({ id });
      if (success) {
        getAllVehicles();
      }
      SuccessToaster("Vehicle deleted successfully");
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    getAllVehicles();
  }, []);

  return (
    <Layout>
      <AddBookingVehicle
        handleClose={() => setShowDialog(false)}
        open={showDialog}
        handleSubmitFunc={getAllVehicles}
      />
      <Box
        sx={{ backgroundColor: colors.lightGray, p: 3, borderRadius: "12px" }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ bgcolor: colors.white, p: 2, borderRadius: "12px" }}
        >
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">
              Moving Vehicles
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage="Moving Vehicles" />
          </Grid>
        </Grid>

        <Box
          sx={{
            mt: 2,
            bgcolor: colors.white,
            p: 2,
            borderRadius: 4,
            textAlign: "right",
          }}
        >
          <PrimaryButton
            onClick={() => setShowDialog(true)}
            title="Add New Vehicle"
          />
        </Box>

        <Box sx={{ mt: 2, bgcolor: colors.white, p: 2, borderRadius: 4 }}>
          {listLoader ? (
            <Box sx={{ textAlign: "center" }}>
              <CircularProgress color="success" />
            </Box>
          ) : (
            <>
              <TableContainer component={Paper} sx={{ my: 2 }}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow sx={{ bgcolor: colors.primary }}>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Image
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Name
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Type
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Deck Height
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Door Opening
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Inside Dimension
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Price
                      </TableCell>
                      <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataList?.map((row, index) => (
                      <TableRow
                        sx={{
                          bgcolor: index % 2 ? colors.lightGray : "white",
                        }}
                        key={row.user_name}
                      >
                        <TableCell>
                          <img
                            src={row?.image}
                            alt="vehicle"
                            width={50}
                            height={50}
                          />
                        </TableCell>
                        <TableCell>{row?.name ?? "-"}</TableCell>
                        <TableCell>{row?.type ?? "-"}</TableCell>
                        <TableCell>{row?.deck_height ?? "-"}</TableCell>
                        <TableCell>{row?.door_opening ?? "-"}</TableCell>
                        <TableCell>{row?.inside_dimension ?? "-"}</TableCell>
                        <TableCell>{row?.price ?? "-"}</TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex" }}>
                            <IconButton
                              onClick={() => deleteItem(row?.id)}
                              size="small"
                            >
                              <Delete color="error" />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </Box>
      </Box>
    </Layout>
  );
}

export default MovingVehicle;
